import * as React from 'react';
import { SVGProps } from 'react';

const IconTopRightSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.343 6.343v1.994l7.899.007-8.606 8.606 1.414 1.414 8.606-8.606.007 7.899h1.994V6.343H6.343Z" />
  </svg>
);
export default IconTopRightSizeM;
